"use client";

import React from "react";
import dynamic from "next/dynamic";

const QRCodeModal = dynamic(
  () => import("modules/common/components/qrCode/QRCodeModal"),
  {
    ssr: false,
  }
);

export default function DynamicQRCodeModal() {
  return <QRCodeModal />;
}
